// extracted by mini-css-extract-plugin
export var content = "_8g-3";
export var list = "_8g-4";
export var settingsContent = "_8g-7";
export var settingsPanel = "_8g-8";
export var state = "_8g-6";
export var triggerBadge = "_8g-2";
export var triggerButton = "_8g-1";
export var triggerShell = "_8g-0";
export var unreadDot = "_8g-5";